import DocumentTypeService from '../services/documentTypeService'
import {
  arrayToDocumentTypeList,
  objectToDocumentType
} from './documentTypeStoreUtils'

export default {
  namespaced: true,
  state: () => ({
    documentsType: [],
    isDocumentsTypeBusy: false,
    documentsTypeItemKey: 'idTipoDocumento',
    documentsTypeItemText: 'descripcion',
    documentsTypeTableLabels: {
      loadingText: 'Buscando los tipos de documento...',
      noDataText: 'No hay tipos de documentos'
    },
    documentTypeHeaders: [
      { text: 'Clave', value: 'clave', width: '130' },
      { text: 'Nombre', value: 'nombre', width: '420' },
      { text: 'Acciones', value: 'actions', width: '180' }
    ],
    documentTypeDeleteLabels: {
      questionText:
        '¿Estás seguro que deseas eliminar el tipo de documento: @?',
      descriptionText:
        'Al eliminar este tipo de documento si ya existían documentos generados previamente estos no se verán afectados.',
      positiveButtonText: 'Eliminar',
      negativeButtonText: 'Cancelar'
    },
    documentTypeVisibilityTrueLabels: {
      questionText: '¿Quieres mostrar nuevamente este tipo de documento: @?',
      descriptionText:
        'Una vez que aceptes se mostrará y podrás hacer uso de este tipo de documento nuevamente.',
      positiveButtonText: 'Aceptar',
      negativeButtonText: 'Cancelar'
    },
    documentTypeVisibilityFalseLabels: {
      questionText: '¿Estás seguro que deseas ocultar el tipo de documento: @?',
      descriptionText:
        'Al dar aceptar ya no podrás hacer uso de este tipo de documento.',
      positiveButtonText: 'Aceptar',
      negativeButtonText: 'Cancelar'
    },
    documentsTypeLimitExceededLabel:
      'Se llegó al límite de tipos de documentos permitidos',
    msgDocumentTypeServicePutError:
      'El tipo de documento no pudo ser actulizado.',
    msgDocumentTypeServiceDeleteError:
      'El tipo de documento no pudo ser eliminado.',
    msgDocumentTypeServiceError:
      'No se pudo realizar la operación solicitada sobre el tipo de documento.'
  }),
  mutations: {
    SET_DOCUMENTS_TYPE(state, documentsType) {
      state.documentsType = documentsType
    },
    SET_DOCUMENTS_TYPE_BUSY(state, isBusy) {
      state.isDocumentsTypeBusy = isBusy
    }
  },
  actions: {
    getDocumentsType({ commit }) {
      const service = new DocumentTypeService()
      commit('SET_DOCUMENTS_TYPE', [])
      commit('SET_DOCUMENTS_TYPE_BUSY', true)

      return new Promise((resolve, reject) => {
        service
          .getDocumentsType()
          .then(result => {
            if (result.data.successful.code == 'DOCUMENTTYPE-GET-200') {
              let newList = arrayToDocumentTypeList(result.data.data)
              commit('SET_DOCUMENTS_TYPE', newList)
              resolve(result.data.successful.code)
            } else {
              reject(result)
            }
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_DOCUMENTS_TYPE_BUSY', false)
          })
      })
    },
    createDocumentType({ commit, state }, data) {
      const service = new DocumentTypeService()

      return new Promise((resolve, reject) => {
        service
          .createDocumentType(data)
          .then(result => {
            if (result.data.successful.code == 'DOCUMENTTYPE-POST-200') {
              let newDoc = objectToDocumentType(result.data.data)
              let newList = [newDoc, ...state.documentsType]
              commit('SET_DOCUMENTS_TYPE', newList)
              resolve(newDoc)
            } else {
              reject(result)
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    updateDocumentType({ commit, state }, data) {
      const service = new DocumentTypeService()
      data = Object.assign({}, data)
      const id = data.idTipoDocumento
      delete data['idTipoDocumento']

      return new Promise((resolve, reject) => {
        service
          .updateDocumentType(id, data)
          .then(result => {
            if (result.data.successful.code == 'DOCUMENTTYPE-PUT-200') {
              let updDoc = objectToDocumentType(result.data.data)
              let newList = state.documentsType.map(d => {
                return d.idTipoDocumento == id ? Object.assign(d, updDoc) : d
              })
              commit('SET_DOCUMENTS_TYPE', newList)
              resolve(updDoc)
            } else {
              reject(result)
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    deleteDocumentType({ commit, state }, data) {
      const service = new DocumentTypeService()

      return new Promise((resolve, reject) => {
        service
          .deleteDocumentType(data)
          .then(result => {
            if (result.data.successful.code == 'DOCUMENTTYPE-DELETE-200') {
              let newList = state.documentsType.filter(d => {
                return d.idTipoDocumento != data
              })
              commit('SET_DOCUMENTS_TYPE', newList)
              resolve(result)
            } else if (result.data.successful.code == 'DOCUMENTTYPE-420'){
              resolve(result)
            } else {
              reject(result)
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  },
  getters: {
    documentsType(state) {
      return state.documentsType
    },
    documentsTypeItemKey(state) {
      return state.documentsTypeItemKey
    },
    documentsTypeItemText(state) {
      return state.documentsTypeItemText
    },
    documentTypeHeaders(state) {
      return state.documentTypeHeaders
    },
    isDocumentsTypeBusy(state) {
      return state.isDocumentsTypeBusy
    },
    documentsTypeLoadingText(state) {
      return state.documentsTypeTableLabels.loadingText
    },
    documentsTypeNoDataText(state) {
      return state.documentsTypeTableLabels.noDataText
    },
    documentTypeDeleteLabels(state) {
      return state.documentTypeDeleteLabels
    },
    documentTypeVisibilityTrueLabels(state) {
      return state.documentTypeVisibilityTrueLabels
    },
    documentTypeVisibilityFalseLabels(state) {
      return state.documentTypeVisibilityFalseLabels
    },
    documentsTypeLimitExceededLabel(state) {
      return state.documentsTypeLimitExceededLabel
    },
    isExceeded(state) {
      return state.documentsType.length > 999
    },
    msgDocumentTypeServiceError(state) {
      return state.msgDocumentTypeServiceError
    },
    msgDocumentTypeServicePutError(state) {
      return state.msgDocumentTypeServicePutError
    },
    msgDocumentTypeServiceDeleteError(state) {
      return state.msgDocumentTypeServiceDeleteError
    }
  }
}
